module.exports = "<button ng-if=\"$ctrl.loaded && $ctrl.label && $ctrl.isBuyable\" class=\"basket\" title=\"{{ $ctrl.label | translate}}\" ng-click=\"$ctrl.goPurchase()\" ga-track-event=\"['My Catalog', 'Click', '{{ $ctrl.label | translate | escapeSingleQuote }} _ {{ $ctrl.product.title | escapeSingleQuote }}']\">\n  <img src=\"{{ $ctrl.icon }}\" alt=\"/img/basket.png\"/>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vehicle/catalog/components/products-basket/products-basket.html
// module id = 1100
// module chunks = 0